import { defineMessages } from 'react-intl';

export default defineMessages({
  autoBatchingNumberOrdersPerBatch: {
    description: 'Orders > Other Actions > Auto Create Batches - Number of Orders Per Batch',
    defaultMessage: 'Orders per batch:',
    id: 'Jr2C+y',
  },
  autoBatchingNumberOfBatches: {
    description: 'Orders > Other Actions > Auto Create Batches - Number of Batches',
    defaultMessage: 'Number of batches:',
    id: 'bNTD/T',
  },
  autoBatchingWillResultInUnevenOrderCount: {
    description: 'Orders > Other Actions > Auto Create Batches - Warning message for uneven Order count.',
    defaultMessage: 'Order count per batch may vary, as the number of orders is not evenly divisible.',
    id: 'hq0d3p',
  },
});
